import CalculatorBranding from './calculator-branding';
import SalesPitchTextContainer from './sales-pitch-text-container';
import Spacer from '@/common/components/spacer';
import { getDynamicCurrency } from '@/util-conversion/currency';
import CalculatorSalesPitchCallToAction from './calculator-sales-pitch-call-to-action';

export interface CalculatorSalesPitchProps {
  isOnPDP: boolean;
  totalSavings: number;
  handleOpen: () => void;
}

export default function CalculatorSalesPitch({
  isOnPDP,
  totalSavings,
  handleOpen,
}: CalculatorSalesPitchProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleOpen}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          handleOpen();
        }
      }}
      className="cursor-pointer"
    >
      <SalesPitchTextContainer
        isOnPDP={isOnPDP}
        showSavings={true}
        showSavingsCalculatorV2={false}
      >
        <h1 className="z-1 inline">{getDynamicCurrency(totalSavings)}+</h1>
        <Spacer variant="height16" />
        <CalculatorSalesPitchCallToAction
          isOnPDP={isOnPDP}
          showSavingsCalculatorV2={false}
        />
      </SalesPitchTextContainer>
      <CalculatorBranding showSavingsCalculatorV2={false} />
    </div>
  );
}
